import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import {
  getPartnerMaterialDownloadContract,
  type GetPartnerMaterialDownloadResponse,
  type PartnerMaterialLocale
} from '@bliks-io/contracts';

/** A short-lived signed link; the storage answers with `attachment`, so the browser saves it. */
export function usePartnerMaterialDownload() {
  return useMutation({
    mutationFn: async ({ id, locale }: { id: string; locale: PartnerMaterialLocale }) => {
      const { data } = await apiClient.get<GetPartnerMaterialDownloadResponse>(
        getPartnerMaterialDownloadContract.path.replace(':id', id),
        { params: { locale } }
      );
      return data;
    }
  });
}
